export interface Direction {
    id: string
    dirLib: string
    dirLibLong: string
    description: string
    type?: string
}

export interface Domaine {
    id: string
    dirLib?: string
    domLib?: string
    domLibLong?: string
    description?: string
}

export interface Agence {
    id: string
    dirLib?: string
    domLib?: string
    ageLib?: string
    ageLibLong?: string
    description?: string
}

interface Site {
    id: string
    sitLib: string
    sitInsee?: number | null
    sitAdr: string
    sitLoc?: string | null
    sitPays?: string | null
    sitLocalite?: string | null
    sitCp?: string | null
    sitLat?: number | null
    sitLong?: number | null
    sitTel?: string | null
    sitEmail?: string | null
    sitHoraires?: {
        jours?: Record<string, {
            ouverture?: string | null
            fermeture?: string | null
            pause?: { debut?: string | null; fin?: string | null } | null
        } | null>
        source?: string | null
        notes?: string | null
    } | null
    sitParkingAuto?: boolean | null
    sitParkingVelo?: boolean | null
    sitAccessible?: boolean | null
    sitRestoEntreprise?: boolean | null
}

interface Tag {
    tagLib?: string
    tagLibLong?: string
    tagColorType?: string
}

export interface Agent {
    id: string
    fsdum?: string
    nni: string
    firstName?: string
    lastName?: string
    email?: string
    description?: string
    fct?: string
    telMob?: string
    telFix?: string
    sites?: Site[]
    tags?: Array<Tag>
}

interface ContactEquipe {
    id: string
    conCham: string
    conString: string
}

export interface Section {
    id: string
    secLib: string
    description?: string
    agents?: Agent[]
}

export interface Equipe {
    id: string
    dirLib: string
    domLib: string
    ageLib: string
    equLib: string
    equDesc?: string
    equMis?: string
    contacts?: ContactEquipe[]
    sections?: Section[]
}

export interface PageMeta {
    page: number
    limit: number
    total: number
    pageCount: number
}
export interface Paged<T> {
    data: T[]
    meta: PageMeta
}

export function keyDirection(dirLib: string): string {
   return dirLib
}

export function keyDomaine(dirLib: string, domLib: string): string {
   return `${dirLib}::${domLib}`
}

export function keyAgence(dirLib: string, domLib: string, ageLib: string): string {
    return `${dirLib}::${domLib}::${ageLib}`
}

export function keyEquipe(dirLib: string, domLib: string, ageLib: string, equLib: string): string {
    return `${dirLib}::${domLib}::${ageLib}::${equLib}`
}

export function keySection (dirLib: string, domLib: string, ageLib: string, equLib: string, secLib: string): string {
    return `${dirLib}::${domLib}::${ageLib}::${equLib}::${secLib}`
}
